import styled from 'styled-components';

const Root = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  &:hover {
    background-color: var(--tonal);
  }
  &:active {
    background-color: var(--tonal-deep);
  }
  &:hover,
  &:active {
    .material-symbols-rounded {
      color: var(--text-secondary);
    }
  }
  .material-symbols-rounded {
    font-size: 1.25rem;
    font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    color: var(--text-tertiary);
  }
`;

const PlayButton = ({ autoPlay, onClick }: { autoPlay: boolean; onClick: () => void }) => {
  return (
    <Root role='button' tabIndex={0} className='playButton' onClick={onClick}>
      <span className='material-symbols-rounded'>{autoPlay ? 'pause' : 'play_arrow'}</span>
    </Root>
  );
};

export default PlayButton;
